<template>
  <div class="annual_invalid_registered_judge" style="position:relative">
    <div class="query_wapper">
      <div class="query_item" style="margin-right:10px">
        <el-select
            :popper-append-to-body="false"
            placeholder="年份查询"
            style="width:200px"
            clearable
            v-model="query.oldYear"
        >
          <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按项目查询"
          style="width:200px"
          clearable
          v-model="query.project"
        >
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按性别查看"
          style="width:200px"
          clearable
          v-model="query.gender"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          @change="handleSearch"
          style="width:200px;"
          placeholder="按等级查询"
          :popper-append-to-body="false"
          clearable
          v-model="query.refereeRank"
        >
          <el-option value="国际级" label="国际级"></el-option>
          <el-option value="国家级" label="国家级"></el-option>
          <el-option value="荣誉级" label="荣誉级"></el-option>
          <el-option value="一级" label="一级"></el-option>
          <el-option value="二级" label="二级"></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          styke="width:200px"
          placeholder="按学校名称查看"
          v-model="query.schoolId"
          clearable
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" style="margin-right:10px">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:290px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item" style="margin-right:0px">
        <el-button
          style="width:90px;padding:12px 0;text-align:center"
          type="primary"
          @click="exportExcel"
        >导出EXCEL</el-button>
        <el-button style="width:90px" type="warning" @click="print">打印</el-button>
      </div>
    </div>
    <div class="titles">
      <p>{{schoolName}}年度失效注册裁判员汇总表</p>
      <p>
        共
        <span>{{total}}</span>条数据
      </p>
    </div>
    <printTable
      :printTitle="schoolName + '年度失效注册裁判员汇总表'"
      ref="print_table"
      :printColumns="printColumns"
      :printTableData="printTableData"
    ></printTable>
    <el-table border style="width:100%;margin-top:20px" :data="tableData">
      <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" min-width="160"></el-table-column>
      <el-table-column prop="genderText" align="center" label="性别" width="60"></el-table-column>
      <el-table-column prop="nation" align="center" label="民族" width="80"></el-table-column>
      <el-table-column prop="schoolName" align="center" label="学校名称" min-width="180"></el-table-column>
      <el-table-column prop="phone" align="center" label="手机号码" width="120"></el-table-column>
      <el-table-column align="center" label="出生年月" width="100" prop="birthdayText"></el-table-column>
      <el-table-column prop="idCard" align="center" label="身份证号码" width="180"></el-table-column>
      <el-table-column align="center" label="职称" width="100" prop="professionalRanks"></el-table-column>
      <el-table-column align="center" label="最后学历" width="100" prop="educationText"></el-table-column>
      <el-table-column align="center" label="注册项目" width="100" prop="projectNewText"></el-table-column>
      <el-table-column label="裁判等级" align="center" width="100" prop="refereeRank"></el-table-column>
      <el-table-column label="批准时间" align="center" width="100" prop="passDate">
        <template slot-scope="{row}">
          <span>{{formatTime(row.passDate)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import printTable from "@/components/print-table";
import registerData from "@/assets/json/register.json";

import { refereeList, societyAuditReferee } from "@/api/judge.js";
import { page, table, message, formatPrintTableData, selectiveYear } from "@/common/js/mixins";
import { getSchool } from "@/api/athletes";
import { method } from "@/utils/utils";
import { baseUrl } from "@/utils/config";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page, table, message, formatPrintTableData, selectiveYear],
  components: {
    printTable
  },
  data() {
    return {
      query: {
        isOld: 1,
        oldYear: null,
        gender: "",
        project: "",
        refereeRank: "",
        keyword: "",
        schoolId: ""
      },
      printColumns: [
        {
          title: "序号",
          key: "index",
          width: 50
        },
        {
          title: "姓名",
          key: "name",
          width: 80
        },
        {
          title: "性别",
          key: "genderText",
          width: 40
        },
        {
          title: "民族",
          key: "nation",
          width: 80
        },
        {
          title: "学校名称",
          key: "schoolName"
        },
        {
          title: "手机号码",
          key: "phone"
        },
        {
          title: "出生年月",
          key: "birthdayText"
        },
        {
          title: "身份证号码",
          key: "idCard"
        },
        {
          title: "职称",
          key: "professionalRanks",
          width: 70
        },
        {
          title: "最后学历",
          key: "educationText",
          width: 80
        },
        {
          title: "注册项目",
          key: "projectNewText"
        },
        {
          title: "裁判等级",
          key: "refereeRank",
          width: 100
        },
        {
          title: "批准时间",
          key: "passDate"
        }
      ],
      schoolList: [],
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    // 格式化时间
    formatTime() {
      return (data, type = null) => {
        return method.timeFormat(data, type);
      };
    },
    projectList() {
      return registerData.judgeProjectList;
    }
  },
  methods: {
    // 获取学校名称
    getSchoolList() {
      getSchool({})
        .then(res => {
          this.schoolList = res;
        })
        .catch(err => {});
    },
    // 打印
    async print() {
      let { gender, project, refereeRank, schoolId } = this.query;
      let { list } = await refereeList({
        ...this.query,
        pageNo: 1,
        pageSize: 9999,
        gender: !gender && gender !== 0 ? null : gender,
        project: !project ? null : project,
        refereeRank: !refereeRank ? null : refereeRank,
        schoolId: !schoolId ? null : schoolId
      });
      list.filter(item => {
        item.passDate = method.timeFormat(item.passDate);
      });
      // 调用公共方法打印（方法在mixins.js)
      this.getPrintData(list, "landscape");
    },
    // 表格导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          if (this.query[k])
            params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      let type = JSON.parse(getSession("userInfo")).type;
      if (type === 1 || type === 5) {
        params.push("pageNo=" + this.pageNo);
        params.push("pageSize=" + this.pageSize);
      }
      let url =
        baseUrl +
        (type === 1 || type === 5
          ? "/referee/downloadAllList?"
          : "/referee/downloadList?");
      window.location.href = url + params.join("&");
    },
    // 查询
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 列表查询
    getList() {
      let { gender, project, refereeRank, schoolId } = this.query;
      refereeList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gender: !gender && gender !== 0 ? null : gender,
        project: !project ? null : project,
        refereeRank: !refereeRank ? null : refereeRank,
        schoolId: !schoolId ? null : schoolId
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    //this.getList();
    this.getSchoolList();
    this.getYearLists(null, this.getList,6);
  }
};
</script>
<style lang="less" scoped>
.annual_invalid_registered_judge {
  .titles {
    display: flex;
    align-items: center;
    font-size: 22px;
    > p {
      display: flex;
      align-items: center;
      &:first-of-type {
        margin-right: 20px;
      }
      &:last-of-type {
        font-size: 14px;
        > span {
          color: #fd6666;
        }
      }
    }
  }
}
</style>
